import Vue from "vue";
import VueI18n from "vue-i18n";
import VueLocalStorage from "vue-localstorage";

Vue.use(VueI18n);
Vue.use(VueLocalStorage);

const messages = {
	en: {
		websiteName: "SoftCare",
		footer: {
			keepTouch: "Keep in touch"
		},
		global: {
			startNewProject: "Start your project",
			readAboutThis: "Read about this",
			checkOurProjects: "Check our projects",
			getAQoute: "Get A Quote",
			carrers: "Carrers",
			stayInTouch: "Stay in touch with us through social networks",
			projectEstimation: "Your project estimation is around: ",
			getAnEstimation: "Get an estimation",
			becomeAClient: "Become one of our clients",
			goBack: "Go Back",
			goNext: "Go Next",
			share: "Share:",
			facebook: "Facebook",
			linkedIn: "LinkedIn",
			twitter: "Twitter",
			by: "By:",
			targetedClients: "We work passionately with",
			companyProfile: "Download Company Profile"
		},
		project: {
			projectType: "Project type",
			clientName: "Client name",
			liveVersion: "Check live version"
		},
		menu: {
			aboutUs: "About Us",
			blog: "Blog",
			contactUs: "Contact Us",
			projects: "Projects",
			services: "Services"
		},
		form: {
			fullName: "Full Name",
			emailAddress: "Email Address",
			yourReferal: "How did you hear about us?",
			message: "Message",
			sendYourMessage: "Send your message",
			messageSendingError:
				"We can't send your message right now, please try again later.",
			messageSendingSuccess:
				"We will be glad to answer all your queries and get in touch with you. We will reply to you as soon as we can."
		},
		referal: {
			google: "Google Search",
			social: "Social Media: Twitter, LinkedIn",
			friend: "A Friend",
			other: "Other"
		},
		services: {
			softwareServicesTitle: "Software Solutions",
			digitalServicesTitle: "Digital Marketing",
			softwareServicesProcessTitle: "The Lego Method",
			digitalServicesProcessTitle: "Digital Marketing Process"
		}
	},
	ar: {
		websiteName: "سوفت كير",
		footer: {
			keepTouch: "كن على تواصل"
		},
		global: {
			startNewProject: "ابدأ مشروعك الآن",
			readAboutThis: "اقرأ المزيد",
			checkOurProjects: "شاهد معرض أعمالنا",
			getAQoute: "احصل على عرض سعر",
			carrers: "الوظائف",
			stayInTouch: "كن على تواصل معنا عن طريق مواقع التواصل الإجتماعي",
			projectEstimation: "تكلفة مشروعك تبدأ قيمتها من: ",
			getAnEstimation: "احصل على عرض سعر",
			becomeAClient: "انضم لتصبح أحد عملائنا",
			goBack: "العودة",
			goNext: "التالي",
			share: "مشاركة:",
			facebook: "فيسبوك",
			linkedIn: "لينكدإن",
			twitter: "تويتر",
			by: "بواسطة:",
			targetedClients: "نعمل بشغف مع",
			companyProfile: "تحميل الملف التعريفي"
		},
		project: {
			projectType: "نوع المشروع",
			clientName: "العميل المنفذ له العمل",
			liveVersion: "شاهد النسخة الحية"
		},
		menu: {
			aboutUs: "عن سوفت كير",
			blog: "المدونة",
			contactUs: "اتصل بنا",
			projects: "أعمالنا",
			services: "خدماتنا"
		},
		form: {
			fullName: "الإسم بالكامل",
			emailAddress: "البريد الإلكتروني",
			yourReferal: "كيف تعرفت على سوفت كير؟",
			message: "نص الرسالة",
			sendYourMessage: "إرسال",
			messageSendingError: "تعذر إرسال رسالتك فضلاً أعد المحاولة بعد قليل.",
			messageSendingSuccess:
				"نسعد بالتواصل معك والإجابة على كافة الاستفسارات. سنقوم بالرد عليك في أقرب وقت ممكن."
		},
		referal: {
			google: "محرك بحث جوجل",
			social: "مواقع التواصل الإجتماعي: تويتر - لينكدإن",
			friend: "عن طريق صديق",
			other: "أخرى"
		},
		services: {
			softwareServicesTitle: "الحلول البرمجية",
			digitalServicesTitle: "التسويق الرقمي",
			softwareServicesProcessTitle: "أسلوب الليقو",
			digitalServicesProcessTitle: "مراحل التسويق الرقمي"
		}
	}
};

let hrefLang = "";
// let url = 'http://softcare.io/en'
// console.log(url)
// console.log(url.match('\\/ar|/en'))

// // console.log(window.location.href)
// // console.log(window.location.href.match('\\ar|en'))
if (window.location.href.match("\\/ar|/en")) {
	const match = window.location.href.match("\\/ar|/en")[0];
	if (match === "/en") {
		hrefLang = "en";
	} else {
		hrefLang = "ar";
	}
	Vue.localStorage.set("userLang", hrefLang);
}
// console.log(hrefLang)
// console.log(Vue.localStorage.get('userLang'))

export default new VueI18n({
	messages,
	locale: hrefLang || Vue.localStorage.get("userLang") || "ar"
});



// WEBPACK FOOTER //
// ./src/i18n.js